
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index1ccY3C7mXoMeta } from "/opt/build/repo/pages/carta-vini/index.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as indexVEPyDcLLH7Meta } from "/opt/build/repo/pages/menu/index.vue?macro=true";
import { default as component_45stubkIiOIRL238Meta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.6_@types+node@20.19.32_cac@6.7.14_db0@0.3.4_eslint@8.57_f74128c39824ad93d1c439882146bd58/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubkIiOIRL238 } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.6_@types+node@20.19.32_cac@6.7.14_db0@0.3.4_eslint@8.57_f74128c39824ad93d1c439882146bd58/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "carta-vini___it",
    path: "/carta-vini",
    meta: index1ccY3C7mXoMeta || {},
    component: () => import("/opt/build/repo/pages/carta-vini/index.vue")
  },
  {
    name: "carta-vini___en",
    path: "/en/wine-list",
    meta: index1ccY3C7mXoMeta || {},
    component: () => import("/opt/build/repo/pages/carta-vini/index.vue")
  },
  {
    name: "carta-vini___de",
    path: "/de/weinkarte",
    meta: index1ccY3C7mXoMeta || {},
    component: () => import("/opt/build/repo/pages/carta-vini/index.vue")
  },
  {
    name: "index___it",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "menu___it",
    path: "/menu",
    meta: indexVEPyDcLLH7Meta || {},
    component: () => import("/opt/build/repo/pages/menu/index.vue")
  },
  {
    name: "menu___en",
    path: "/en/menu",
    meta: indexVEPyDcLLH7Meta || {},
    component: () => import("/opt/build/repo/pages/menu/index.vue")
  },
  {
    name: "menu___de",
    path: "/de/menu",
    meta: indexVEPyDcLLH7Meta || {},
    component: () => import("/opt/build/repo/pages/menu/index.vue")
  },
  {
    name: component_45stubkIiOIRL238Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubkIiOIRL238
  }
]